module.exports = __webpack_public_path__ + "images/ideal.36e55d1b5065977a0f33b2160c0c87dc.svg";